import { ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks/hooks";
import { Navigate } from "react-router-dom";
import { VerifyToken } from "@/utils/verifyToken";
import { logOut } from "@/redux/feature/auth/authSlice";
import { TUser } from "@/types/types";
import { useCheckFeatureApprovedQuery } from "@/redux/feature/featureFlag/featureFlagApi";
import { FeatureFlagsConstants } from "@/constant";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { token } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();
  const role = "client";
  let user;

  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;

  if (!token) {
    console.log("redirect from here 2");

    const redirect = encodeURIComponent(window.location.href);
    window.location.href = `${client_dashboard_baseUrl}/auth/sign-in?redirect=${redirect}`;
    return null;
  }

  if (token) {
    user = VerifyToken(token);
  }

  if (role !== undefined && (user as TUser)?.role !== role) {
    // Store both pathname and query params (search)
    console.log("redirect from here 1");
    dispatch(logOut());

    return (window.location.href = `${client_dashboard_baseUrl}/auth/sign-in`);
  }

  // check the access also if there is no access will redirect to the main dashboard

  return <>{children}</>;
};

export default ProtectedRoute;
